import React from "react";
import { useSelector } from "react-redux";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ShowPicture from "./ShowPicture";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import PeopleSharpIcon from "@material-ui/icons/PeopleSharp";
import FooterPatientArea from "./FooterPatientArea";
import { translator } from "../../utils/i18n";
import Analyse from "./Analyse";

function WaitingRoomExternal() {
  const infosWaitingRoom = useSelector(state => state.waitingRoom) || {};

  return (
    <div>
      <div className="custom-message custom-success d-flex align-items-center justify-content-start flex-nowrap p-6">
        <CheckCircleIcon /> {translator()._("W_INFORMER_MEDECIN")}
      </div>
      <List>
        {infosWaitingRoom.listPersons.map((item, key) => {
          return (
            <ListItem key={key} className="item-bloc" divider>
              <ListItemAvatar color="secondary">
                <PeopleSharpIcon />
              </ListItemAvatar>
              <ListItemText
                primary={`${item.firstName} ${item.lastName}`}
                secondary={
                  <>
                    <div dangerouslySetInnerHTML={{ __html: item.nameRoom }} />
                    {item.keyMikjaki && (
                      <div>
                        <Analyse item={item} />
                      </div>
                    )}
                  </>
                }
              />

              {item.pictureRoom && <ShowPicture picture={item.pictureRoom} />}
            </ListItem>
          );
        })}
      </List>
      <FooterPatientArea />
    </div>
  );
}

export default WaitingRoomExternal;
